<template>
  <Transition name="pt-loading-fade">
    <div
      v-if="loading"
      class="pt-loading"
      role="status"
      aria-live="polite"
      :aria-label="message"
    >
      <div class="pt-loading__backdrop" />

      <div class="pt-loading__skeleton" aria-hidden="true">
        <div class="pt-loading__skeleton-head">
          <span
            v-for="n in 5"
            :key="`head-${n}`"
            class="pt-loading__bone"
            :class="headBoneClass(n)"
          />
        </div>

        <div
          v-for="row in rows"
          :key="row"
          class="pt-loading__skeleton-row"
        >
          <div class="pt-loading__cell">
            <span class="pt-loading__bone pt-loading__bone--icon" />
            <span class="pt-loading__bone pt-loading__bone--lg" />
          </div>
          <span class="pt-loading__bone pt-loading__bone--md" />
          <span class="pt-loading__bone pt-loading__bone--md" />
          <span class="pt-loading__bone pt-loading__bone--sm" />
          <span class="pt-loading__bone pt-loading__bone--badge" />
        </div>
      </div>

      <div class="pt-loading__center">
        <div class="pt-loading__card">
          <div class="pt-loading__visual">
            <svg class="pt-loading__arcs" viewBox="0 0 52 52" aria-hidden="true">
              <circle
                class="pt-loading__arc pt-loading__arc--1"
                cx="26"
                cy="26"
                r="21"
              />
              <circle
                class="pt-loading__arc pt-loading__arc--2"
                cx="26"
                cy="26"
                r="15"
              />
              <circle
                class="pt-loading__arc pt-loading__arc--3"
                cx="26"
                cy="26"
                r="9"
              />
            </svg>
            <span class="pt-loading__icon-wrap">
              <v-icon :icon="icon" />
            </span>
          </div>

          <div class="pt-loading__copy">
            <h4 class="pt-loading__title">
              {{ message }}
              <span class="pt-loading__dots" aria-hidden="true">
                <span /><span /><span />
              </span>
            </h4>
            <p v-if="hint" class="pt-loading__hint">{{ hint }}</p>
            <div class="pt-loading__progress" aria-hidden="true">
              <span class="pt-loading__progress-bar" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import "@/assets/styles/premium-table-loading.css";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    currentTheme: {
      type: String,
      default: "light",
    },
    icon: {
      type: String,
      default: "mdi-table-sync",
    },
    message: {
      type: String,
      default: "Loading data",
    },
    hint: {
      type: String,
      default: "Fetching records for you",
    },
    rows: {
      type: Number,
      default: 7,
    },
  },
  methods: {
    headBoneClass(index) {
      if (index === 1) return "pt-loading__bone--lg";
      if (index === 5) return "pt-loading__bone--badge";
      if (index % 2 === 0) return "pt-loading__bone--md";
      return "pt-loading__bone--sm";
    },
  },
};
</script>
